(() => {
  function init(root) {
    if (!root || root.dataset.mlOccasionsReady === '1') return;
    root.dataset.mlOccasionsReady = '1';

    const gridSelector = root.dataset.gridSelector || '#product-grid';
    const chips = Array.from(root.querySelectorAll('[data-ml-occasion]'));
    const status = root.querySelector('[data-ml-occasion-status]');
    let active = 'all';

    function getItems() {
      const grid = document.querySelector(gridSelector);
      if (!grid) return [];
      return Array.from(grid.querySelectorAll(':scope > .grid__item, :scope > li'));
    }

    function itemKeys(item) {
      const raw = (item.getAttribute('data-ml-occasions') || '').toLowerCase();
      return new Set(
        raw
          .split(/[,\s]+/)
          .map((s) => s.trim())
          .filter(Boolean)
      );
    }

    function updateStatus(visible, total) {
      if (!status) return;
      if (active === 'all') {
        status.hidden = true;
        status.textContent = '';
        return;
      }
      status.hidden = false;
      status.textContent =
        visible === 1 ? '1 Duft wird angezeigt' : `${visible} von ${total} Düften`;
    }

    function apply() {
      const items = getItems();
      let visible = 0;
      items.forEach((item) => {
        const match = active === 'all' || itemKeys(item).has(active);
        item.classList.toggle('is-ml-occasion-hidden', !match);
        if (match) visible += 1;
      });
      updateStatus(visible, items.length);
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        active = chip.dataset.mlOccasion || 'all';
        chips.forEach((c) => {
          const on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-ml-occasions]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
